export const getAskBarBorderColor = ({
  showValidationMessage,
  showAiSdrGlow,
  isAiSdrFocused,
  theme
}) => {
  if (showValidationMessage) return '#FF7B70';
  if (!showAiSdrGlow) return '#e5e5e5';
  return isAiSdrFocused ? theme.spotlight.color.orange : theme.spotlight.color.orangeMuted;
};